import Cookies from 'js-cookie'

import {
  COOKIE_MARKETING_POPOVER_CAPPED,
  COOKIE_MARKETING_POPOVER_VIEWS_PREFIX
} from './config'

// View counter storing cookie
const VIEW_COOKIE_TTL_DAYS = 365
// The capping flag, checked before the request is sent. 
const CAPPED_COOKIE_TTL_DAYS = 1 / 24

const buildCookieName = (displayId: string) =>
  `${COOKIE_MARKETING_POPOVER_VIEWS_PREFIX}${displayId}`

export const clearStaleViewCounters = (displayId: string): void => {
  const currentName = buildCookieName(displayId)
  let hasRemovedStaleCounter = false

  Object.keys(Cookies.get()).forEach(name => {
    if (
      name.startsWith(COOKIE_MARKETING_POPOVER_VIEWS_PREFIX) &&
      name !== currentName
    ) {
      Cookies.remove(name)
      hasRemovedStaleCounter = true
    }
  })

  if (hasRemovedStaleCounter) {
    clearCapReached()
  }
}

export const readViewCount = (displayId: string): number => {
  const stored = Number(Cookies.get(buildCookieName(displayId)))

  return Number.isFinite(stored) && stored > 0 ? stored : 0
}

export const registerView = (displayId: string): void => {
  Cookies.set(buildCookieName(displayId), String(readViewCount(displayId) + 1), {
    expires: VIEW_COOKIE_TTL_DAYS
  })
}

export const isCapReached = (): boolean =>
  Cookies.get(COOKIE_MARKETING_POPOVER_CAPPED) === 'true'

export const markCapReached = (): void => {
  Cookies.set(COOKIE_MARKETING_POPOVER_CAPPED, 'true', {
    expires: CAPPED_COOKIE_TTL_DAYS
  })
}

export const clearCapReached = (): void =>
  Cookies.remove(COOKIE_MARKETING_POPOVER_CAPPED)
